import {noop} from 'lodash';
import React, {cloneElement, Component} from 'react';
import {MdClear} from 'react-icons/md';
import ReactDOM from 'react-dom';

import styles from './Modal.module.scss';
import {isDescendant} from '../../../utils/dom-utils';

let defaultModalIdCounter = 0;

export default class Modal extends Component {
  constructor(props) {
    super(props);
    this.clickOutsideHandler = this.clickOutsideHandler.bind(this);
  }
  componentDidUpdate(prevProps) {
    const { onHide, onShow, show } = this.props;

    if (show && !prevProps.show && onShow) {
      onShow();
    }
    if (!show && prevProps.show && onHide) {
      onHide();
    }
  }
  defaultId = ++defaultModalIdCounter;
  clickOutsideHandler(event) {
    const { clickOutsideCloses = true, onCloseClick } = this.props;
    if (
      clickOutsideCloses &&
      !isDescendant(ReactDOM.findDOMNode(this).firstElementChild, event.target)
    ) {
      onCloseClick();
    }
  }
  render() {
    const {
      children,
      className = '',
      id = this.defaultId,
      onCloseClick = noop,
      show,
      showCloseButton = true,
      dataAttributes = {},
      showBottomBar = false,
    } = this.props;

    if (!show) {
      return null;
    }
    return (
      <div
        {...dataAttributes}
        className={styles.backdrop}
        onClick={this.clickOutsideHandler}
        data-metrics-location="PU"
      >
        <div className={`${styles.content} ${className} ${showBottomBar ? styles.bottomBarPadding : ''}`}>
          {React.Children.map(children, (child) =>
            cloneElement(child, this.props)
          )}
          {showCloseButton && ( // eslint-disable-next-line
            <a
              id={`modal-close-${id}`}
              className={`${styles.close} e2e-modal-close-button`}
              onClick={onCloseClick}
            >
              <MdClear />
            </a>
          )}
          {
            showBottomBar &&
            <div className={styles['bottom-bar']}>
              <button
                className={styles['buttonBorder']}
                onClick={onCloseClick}
              >
                Close
              </button>
            </div>
          }
        </div>
      </div>
    );
  }
}
